<template>
	<div class="map-container">
		<div ref="amapRef" class="amap-wrapper"></div>

		<div class="map-controls" :style="{ top: computedTop }">
			<div class="level-indicator">当前视图：{{ getCurrentLevelText() }}</div>
			<button
				v-show="currentLevel !== 'national'"
				class="back-btn"
				@click="handleBack"
			>
				← 返回{{ getBackLevelText() }}
			</button>
		</div>
	</div>
</template>

<script>
	// 引入高德地图加载器（官方推荐，解决加载时序问题）
	import AMapLoader from "@amap/amap-jsapi-loader";
	// 弹窗底图改为本地资源，避免外部域名证书/网络异常导致弹窗空白
	import infoBgImg from "@/assets/image/map/info-bg.png";

	// 高德地图配置（需替换为自己的Key）
	const AMAP_CONFIG = {
		key: "e3e3bbe6fa9491a87fef3dc4e0fe4b2a", // 你的高德Web端Key
		version: "2.0", // 高德API版本
		mapStyle: "amap://styles/grey" // 深色风格（适配大屏）
	};

	// 提取图片缓存配置为常量
	const IMAGE_CACHE_CONFIG = {
		STATION:
			"data:image/png;base64,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",
		CABINET:
			"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAARqSURBVFiF7ZjNixxFGMZ/T9XMmmyIifkyGHXjRfCiEfHqwb/Akyf/Oi8eRHJX8CJEghiIHyAixqwsbgzErMm62ZmuejxUVU9nQOyJI3rYgt3qma7u/s3zPvW+VQ1H7aj9t01jBr32iV/v4KrNlrTChYPm1huC2A2Rd756W9f/7row5uYp8wGwJUAGZSADxs6YXPrhX/sOY3K5RgYJbC7mjg/HPHsyZhCBl9REyOBclMClVzuuwwW4XqAACEtFjvoZw/PrAwRjcAIn7K4cZ1fgPn4DwtYFCKH2E2CCFEHqR68BsISSnLAPIXfgDnJVs4YbNzBXuqqYIxDLuFCFVRynzChAGTthugKZ5/DsBtrQ4yq2iVMICmSokPcTftiBAlLAHuX+kYCuSvXKdfi9K8SNkSoA3PgVf7xDzgkro8gaQ6zqQdrsnEMC5uP5gBIFJ+Shb9cBaIoH6yTBCc9hpAalJUNOoLTw7NoAF5TlIc7QrZisuwwkjC2sYVb654Cuv1iUEOeMuxXUoyhoZwCV+bRWBV3/t9AY7+yRTx4biNhSy1IupM7ouw/q9bUCrRVQeqxSmAxXrzFL85qw8wCeRQ4MoeS7OIXwFIrHEDW+Yw0yWkGpQHihYq8macn07hU1LrO2/y7LWsG8o0udW5iNXT6XclyDde4M4cXnKJmxAvy0Q7r/RznfIHv//QsebIoUHzHwkvGbV5hevMBjqXvvAfn+PhlbC4PKeHwCWCXNmIWKLWlDxpvH0ZnzxGHivnOH9ONtOk0QuUJZJlfSkZCrKbgMWfvLl4lpMC5l/PkXPOrHaOkuoLGJZhygFmnBNUxl/SUDXNpiOlRv73f8whZTCba33T2aq00n2ePL3HjA1gw1TKU3nDxF2DxF6AbDTpwmvHyajZTxzzvqmK1W3lYGHCyYjcosrid86TKTv6oq39zgcH+PFKYMa5vX78Glplb2wAf75O1bzBXg4hbTNubuDt32D8zUJ55l62mNy63FYrRPK+05t79nlhM8/QzhXAWcHZC/vsZBk17Q/CokV8o1KhhoNy1S1I1Qc5WAk+eJXQ3jt9c46GZkxXpSmIDk8WCrAQLYstXqnpEREoGMYfNsyYO/fMfhb7sl5AogIWQCMiq7Fq3AOGpnYINUa6hEEEii+UsBjp8lPrhH2r7JQYOjDhOlkKjQjoZjhTxYYrlQhRCwAihCymjWwfZ19tECLkYIERSxQmUL/S3XB1iFU8AiCk/oVwohCGW49RkPbYh139tAFYymIkSIk8UP9EjCsR4sUYrCAbW8liU7IXJZ7bQKIdU1ZECKKuvCDUQsdijmXQPgq+/7hE/xhkVQKKPjBrKQAgqpvotJaHmPIfo3CNIENEGaojCAfOUjv7WZuPnlu9p7IsB0gV1gM5jsiMMUZYMCQROcc00druu9IWB7ByMUAhCRoqWpxAQhFE/w6aG5B1x4IkBg37Bp9a8qQlRZrJIh5ArXCt8SY3u7oIAIIEn1WBTrSmWLfdSO2v+2/QlZJHFX5KHRpQAAAABJRU5ErkJggg==",
		VEHICLE:
			"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAxcSURBVFiF7ZhJbJ3Xdcf/59z7DW/g8ChSEinJoSVbtsk4ci27thet7KRO3AoxgqJOu7CBtCgcIIt001VRQCKaTRbdZFE0RYMOQIu2coUGNdqiLiIpCRo4rth4IOVSA6mJEsfH9/iGb7j3nC6+R80emji7XuDgfu/D/e77fec70z2EDx1KODpFmJkg1OqMaA+PpZdNbmucdwLrK2rUw5TYsSaeNTQEAJR5pdhIV6yQgTdt8kE5d4Gry2K0xyO9LKjXBJOziqNHFCD9IAL6QDAFMDVFwCEGVnh3A6bjssB1QuurURCJC7z6QNQGgXNWyTIsF/s5UVInubWOyeWGTJ6yzU0rzW05c2Ub5lcG4IERAU4JjhzRguRu0HsA9uC+fIwxOUJY65odkbFJezWMwmqYORdbUOQYpce+9NnfGhmOn4wr4S/FAYWBLXbInSLJkWXt7AfXVpO33vmn7/2dFXQdNA2tTdKslcWV4Wwp9Q7bSh4zK4p/eEnuBXk3oCptwY0vLNgWDwWpbUeBRLExWsqNVJ78jed/e/S+wVcNI15pABttoJMCmSu2CC1QjoDBCjAyAHhBcvXSxp+dfu2Nvwg8t72nbs5pErlKWpX1fGF83N2E/FDAns3hEI8vLNjW9qEg6aax7Zgyl01leHL/owee2veH1f7w0/PL0NUGoAKoAtiSrV0JIALABeT920GtZvbe22+e/8bqzNy70vFtV/aduBQl1eUeJE7JnTZp7gWHta6xLgoTSmOb+wpFYf+eJyaffvLQQ3/acbxr9jJpqw2og6oD1AGSF7M6QD0AuSmdFHS9AQz08Y59+4cPd7x9t7myusou00xExfVpx4mi/ADw7F8BJ08AmLoT8ChhZIWxvWN2SClIkEa2SxWKwv7tjzz4mSd++aE/Wd1E+cISqWRQcYDPoZIXcFuA4gDxBaT6QsPQYl7vECKLYO8D235loyU/7qw1N7gLyUvqa3Ek7XBdMTOimJ3UOwEJR4ngrNktJdvptqJAqERx0AefDz11+Olvdr0dW1iCSA5IBkgG1RyqGaApoDngswIUHoDraVBvQBIANLqklQjhzp39D89Pn/kPjqyzLvdZ3pIRb6Rp6oovvq44eRIoLASFEc1MEKI9nDQiG4XVkJXLJK7v0cPPvlyuRhPzyxDfA/NpTxKoS6Cu91uyQnxa3HNJsebG+qzQ+PwypFyNJh49/OzLJK6PlctRSGHSiCyiPYyZCSoMG7CAEqamCLVRHkvrpkW1gJ2JYaTCPhzcdd/wKwsrUJcWmvMpoMUf6S9uB//6gzADUeEfhNvnzQz6nffg5zagFACihY86AhZWoLvvG37lPW+P5yZL4aJMKM3H0ut+sQbB1JQC2tPgzAShXqPc1thXo8CCIkZY3v+FZ14koLTWLN5cHUSyQhPsoK9MgEfKQGiAyNw9D5dALz8Ms/WMZFB1hZmsNaEElPZ/4ZkXGWHZgiJfjYLc1hj1WpG9Cg0CWJkljH+K886gjfpc4EVjIl8dHio/ttaCki+cQracwkEe3w4ejEF/8O/IGu3C1O5MAkNV4BvPIxwrA4sdCBFYLACGkgXWW9DhWvmxOeTf9UKtSLSTdwKLyobDwkUpAI9OERZHaQzDvBnkRtUHqoiZqVSqVh5fW4eKh6qDSi+sSA59fAc499CzSxBVqCq2zAbUi4ErLVDmoM/sAh87A0cMJQewgcCDGh3o7lrlcSGURCQmRSAVMmP5MC/uzwjPTlHxiXEQue2yehhRGxhGyMpxwBR1M2gvZKjmPUgPfWo3+EqjuO6BK3whN17GQy/WIc+Nw9xYl/de2APdFBowRawcG0YoagP1MLntMnCw5yQzEwRcIL0/onijaUQjK8YEqhQbgHKnUE8KKeLa5z4F/uoTCAci0K5+0ImvoXRXurzHeO03EX97Gu7kVZViL9LcgQxAAokAEwTOWdbUaH8/Yf4CoT5BdmsD6W4SO0saWlZVY0itCorkrQAEqgr9vadhf/9fkFYN6I+/iOijwBTAq68hKUXAH30e0YnjlOJmXFQVgImsFxgly8g9SXeTgHArzADYWSVgHRoagmUyogwSyr2qJYIrzEuh0G0lUJpDA0BD8xF0PcA0hxIDI2UQtGeqBLUEyj0UIDbErIZIYQjwBdP1FuyHbZ45JLFFmBQFGIiKSuW1l4vPSrjddT/o9/Gv3Fx/S3misQVlTpMPYygAr7cUO4tKGBD1pGJIpb3WPFONBx7bIKUixCoi8wE17sccBAURAaRUDYnaa80zgIpXEXaklHnVoMd0AxAAl/oUaVNJjRAbL6puebl+bt9DA7+waAA2gFjSw3+Lrs+gb/wOylusn/0WWpm/vdwiBk59HVXeWvMddEwIIktKBsRMGIxA5y6unxNVR0SexAmsUy71K5AWXJicVdT2KrVSTbjic2sdwecMTi9O//e089odKBGTAdgCV9uQq23IuXX40AAX1uHnN+CvNuCvNnvSgL/SgD+7Wqw5t1Y8c7UNYQuQAQbLYCfavTT9k2kGpwSf59a6hCueWqmitlcxOas9DZ5G4MYkCXLP5HLvkbGRBILOpbMXT40/MP7CZgeiDmpCKAR48a/R7cU7sAEpQW/TIIEO/zk6bAGyIBMBHAJsQTYE76zCLJy7eErFd5SRiEfG1uVirA/ykgCnAQAGJ08Afa/TZl9I5bxkTESWlAIGYgLixuJia2jXfQ/2V4KBZkaiCqKtpKG9rFE4EIFBxCBmEBuAAxBZwIQ3AI2JQHsGNUha7cX3v//9fybCCgHrBN5gw21qcbri13OcvyL4yyNSZJKRCUW7IkE5dynb3DAnQNAC8SYIjbnp6ddLgXZHBxDYCEQBjI0BGwMmgppihg0KMRHQu6e2d00BjI1AowMISoF256anXwehAeJNIGgZ5iRlmwfl3KFdEYxMKG7Ug5OzilpdA1cX00pzB00FWQeQJoHqrdXly2//6M3jfaEmu2sIwjKIQzDHYBspmxBkIyUTFzA2UurdYy6BOQSHZdDuGoK+UJO3f/Tm8dbq8mUC1QFpCrKOg6amleaBqwtqdcXkrN6MSlsnuZ1VO9zOQ+5DWZO8XyyGRLEdSqNEMlqqjYzvP3Dw830D1dHrLeQbbXjJoRAovEKVtuIlwQBgEAegwQrMziqCzUbr2tzb//VGt746r8rXQHqNCcvssE5x0JRNdFYrQYbrLbd1witywdQU4cuTwIbQUF+ATpoQgaE2IIhnJiVVgkva7vr8+Uve2Hx0R237cAWlMCSmAEQBFc4QgsIYXC7DbOtDMNanYSnQdOH82bfO/vg/T7okuaqKJSZdUcU6TLABca1ckqRS1azZXfLYNy947jng9mOnEl46xpiE2dEaCDrddmwSrVLJ9Kv6mlEZFuVhANuIZBvAgzsentg3VNu2u3/b8GgAKjEVJiMKyaHd5trqtfX62pWl92fPA7KhymsA1phk1ROvEpm6dn3Tx9QqlyrJUrWRYwYex16SraPn7aluclaBQ7KUdt1w12RJJe3YPCOyJYiIgjRnRaqgDlSbS+/P1K8rzhA0VrAF9cKWkiOIU1BChDYUmyBqMHRDCOui2CA2G+q6m65sOnE7ypbYO1RHBJOnFMduIt0CSIqjChydEmw7hOrmUo7SEBKksB2vXA48icsUmgLcBqSpoAqIylCJiSVQYQYAYhGI5iBOFNohaBvgTSVpMlFDTbBZHNxNcXDfXM9Xt437ex3cf6rWByMsg6Qi8OXJkb3fOn36rdgO1t6z/ZV33PoKKOw7EI7e/+kD+8a70z/53tcZpgPltiDr/IytD3zs5pEXiT1RdPDAM787PDD46sWri6h3E3Tn3sXORx7F3vv34fz1K988O/fOPxrV1DAnn0zz6FbIO9pvSSOyGaXBre03Q2FpZM8D/1YrlfYMV/sgqlhvt7CZJhcuzf/Pr/4c2m93gH6MBma5r/9LKvm3B8tVqCoa3TaMCb7Sajb/9efUwLwDEgCOThFOgrF/lFCvESptHguHObdd1mpEaKY/LIXhZxRAN0vfov74c9RKNXAlWcxWBe1KkSHmrimeRc8Z7q21/yPgLWtVi88+M0FYmSXsHyXgIFC/QDvKnRfCKPguVJE6eWG5FZ9Aba8Cp4G5a4qRiSJ9HTlSlBt3n6N/ZsDe0JvPHJ0qrntdgH2D6SmFZhc24ueBrbgK3NQWPlJjn/SgAriQR776N782+bW/f+7Wez+dEv5/fHLjfwHXwodPIKSODQAAAABJRU5ErkJggg==",
		BATTERY:
			"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAN/SURBVFiF7ZdNixxVGIWf897qngkq6ghiFBfu/MgIZjEgRDeKzELcufCP+J/0HxjIXiXKoJNN/BjEhclCXJiE6a6697i4t3omAWHKsXb9QtFV1bfee+q8X6dga1vb2tZmNV3Wwf4tf5kzn+q8N4OFQ3xx/KE+u4z/7rIAKXwcZ+cbkDISfHJZ95MAvn3L14s5JLAyxhQXwsa4MlfRtSOI/Zv+HBFOFXqYr374QN9fdM9JIX7rplfAsj1kCjiDM7bBpTkNkEAJkep1JRWA1Z2PtHvRPScxaFiGsAuQwQN2hpLrvccABkQCJaBDJKyAYnam7DkJoMCMjA3gNeSMybjkVhxAVPYoCSKhKFgdqEOKTSL8/wCpYbR7KD3O68ZiY9JtazcG1YHbDgFyYDQtreICazYmwENlsKzBPS5rnFeQV5BP4Y094hmhvAKvcVuzYX1qX5sEkPJEYfS4nDteuAKHb5Ke363Xeai/lAoONx8TbFqR1BxzY2MDwAOowOE+iyzIfQ19Gd+rr+GWwZ4xxO3dKyONFQ+4DPjd10nPPYvWQHa91/ITl/bM2C8n2NQ2U6dFAWfjIrvgq3vEtdfo1m3zkqEUrNKKKlsUbYpoNoCiNWQDRcZ4meD9d1j25wKXUm09BMIYCxeEQRM5nNxmxqHm1hMPrrFc7qKVW5UD7x2wc6NV/W/3yV/fpW9QmTq9pvfBsRcav3qV9PIrpPW/LO8zPrpLj2vO4srifAB1ThQYdpbol98ZbPz0U8TeHun88qNj1g8fUdJuBWY3H7MBbP4lWTY/n6jPKztnlZdedHdwQ1fGdff+YDg5YUg7rpCkNginterpenAsRqnyKFmYgjxW8eoUH9326Zk4FGCpCpoZc7DJZglXcYdVa5MCjLn4420e9b2cFlU5CCTJG504F8D2/pYe+yUEFqwN935l/ed9shIN2ZgXCGHNWiQNJ01OjbpPCSP4+wHl5JjTqFrQEaj9X4H+h2+gySFujCgCuWv6UPDgL4afvuFhBJAgugosOlBU/jR3iNGZUnZnKUsB9tqy5Vxw7DS5L0tLoQ5FZ0VSlf5zAySQOisWMkZOhJPsshkkAFJUcEooFkKdRWiiXJ0OUEqghQjquQegoKZUNpkmURd1SB3SQrTCmXXUfUfH9YBkUZwwizqf/cRn55ir1CKREkEHmG8n7bm1rW1ta/PaPxdc+CfqsaABAAAAAElFTkSuQmCC",
		COMPARTMENT:
			"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAN/SURBVFiF7ZdNixxVGIWf897qngkq6ghiFBfu/MgIZjEgRDeKzELcufCP+J/0HxjIXiXKoJNN/BjEhclCXJiE6a6697i4t3omAWHKsXb9QtFV1bfee+q8X6dga1vb2tZmNV3Wwf4tf5kzn+q8N4OFQ3xx/KE+u4z/7rIAKXwcZ+cbkDISfHJZ95MAvn3L14s5JLAyxhQXwsa4MlfRtSOI/Zv+HBFOFXqYr374QN9fdM9JIX7rplfAsj1kCjiDM7bBpTkNkEAJkep1JRWA1Z2PtHvRPScxaFiGsAuQwQN2hpLrvccABkQCJaBDJKyAYnam7DkJoMCMjA3gNeSMybjkVhxAVPYoCSKhKFgdqEOKTSL8/wCpYbR7KD3O68ZiY9JtazcG1YHbDgFyYDQtreICazYmwENlsKzBPS5rnFeQV5BP4Y094hmhvAKvcVuzYX1qX5sEkPJEYfS4nDteuAKHb5Ke363Xeai/lAoONx8TbFqR1BxzY2MDwAOowOE+iyzIfQ19Gd+rr+GWwZ4xxO3dKyONFQ+4DPjd10nPPYvWQHa91/ITl/bM2C8n2NQ2U6dFAWfjIrvgq3vEtdfo1m3zkqEUrNKKKlsUbYpoNoCiNWQDRcZ4meD9d1j25wKXUm09BMIYCxeEQRM5nNxmxqHm1hMPrrFc7qKVW5UD7x2wc6NV/W/3yV/fpW9QmTq9pvfBsRcav3qV9PIrpPW/LO8zPrpLj2vO4srifAB1ThQYdpbol98ZbPz0U8TeHun88qNj1g8fUdJuBWY3H7MBbP4lWTY/n6jPKztnlZdedHdwQ1fGdff+YDg5YUg7rpCkNginterpenAsRqnyKFmYgjxW8eoUH9326Zk4FGCpCpoZc7DJZglXcYdVa5MCjLn4420e9b2cFlU5CCTJG504F8D2/pYe+yUEFqwN935l/ed9shIN2ZgXCGHNWiQNJ01OjbpPCSP4+wHl5JjTqFrQEaj9X4H+h2+gySFujCgCuWv6UPDgL4afvuFhBJAgugosOlBU/jR3iNGZUnZnKUsB9tqy5Vxw7DS5L0tLoQ5FZ0VSlf5zAySQOisWMkZOhJPsshkkAFJUcEooFkKdRWiiXJ0OUEqghQjquQegoKZUNpkmURd1SB3SQrTCmXXUfUfH9YBkUZwwizqf/cRn55ir1CKREkEHmG8n7bm1rW1ta/PaPxdc+CfqsaABAAAAAElFTkSuQmCC"
	};

	export default {
		name: "VdataStylePowerStationMap",
		props: {
			data: {
				type: Object,
				default: () => {
					return {
						// 1. 全国层级：各省换电站总数
						national: [
							{
								code: "370000",
								name: "山东",
								count: 56,
								center: [119.0, 36.5504]
							}
						],
						// 2. 省份层级：各市换电站总数（以山东、广东为例）
						province: {
							370000: [
								// 山东省
								{
									code: "370200",
									name: "青岛",
									count: 15,
									center: [120.3022, 36.2172]
								}
							]
						},
						// 3. 区市层级：具体换电站位置（经纬度为GCJ-02，适配高德）
						city: {
							370200: [
								// 青岛市
								{
									name: "联合智捷工厂换电站",
									pos: [120.3822, 36.0715],
									assetSn: "LHBPU3LHZJ3702812023091700445",
									address: "山东省青岛市胶州市上合村街道联合智捷工厂",
									assetType: "CABINET",
									extraMap: {
										deploymentCode: "6764622"
									}
								},
								{
									name: "元宇宙产业创新园换电站",
									pos: [120.1685, 35.9938],
									assetSn: "LHBPU3LHZJ3702812023091500019",
									address: "山东省青岛市市南区元宇宙产业创新园",
									assetType: "CABINET",
									extraMap: {
										deploymentCode: "212331232"
									}
								},
								{
									name: "宜家家居换电站",
									pos: [120.4562, 36.1123],
									assetSn: "LHBPU3LHZJ3702812023091500019",
									address: "山东省青岛市崂山区宜家家居旁",
									assetType: "CABINET",
									extraMap: {
										deploymentCode: "4654651"
									}
								}
							]
						}
					};
				}
			},
			center: {
				type: Array,
				default: () => [108.0, 36.0] // 默认全国中心点
			},
			top: {
				type: [String, Number],
				default: 920
			}
		},
		data() {
			return {
				amap: null, // 高德地图实例
				AMap: null, // 存储局部AMap对象
				currentLevel: "national", // 当前层级：national(全国)/province(省份)/city(区市)
				currentAdcode: "", // 当前选中的行政区划代码（如370000=山东）
				currentName: "", // 当前选中的名称（如山东省、青岛市）
				dataLayers: [], // 存储数据层实例，用于切换层级时清除
				imageCache: {} // 地图渲染图片
			};
		},
		computed: {
			computedTop() {
				return typeof this.top === "number"
					? `${this.top}px`
					: this.top || "920px";
			}
		},
		watch: {
			data: {
				handler(newVal, oldVal) {
					// 数据更新时，重新渲染当前层级
					this.$nextTick(() => {
						// 判断数据来源是否发生了变化
						if (oldVal?.assetType && newVal?.assetType !== oldVal?.assetType) {
							this.currentLevel = "province";
							this.handleBack();
						} else {
							this.renderCurrentLayer();
						}
					});
				},
				deep: true, // 因为 data 是对象，需要深度监听
				immediate: false // 不需要立即执行（mounted 已处理首次渲染）
			},
			center: {
				handler(newVal) {
					if (this.amap && Array.isArray(newVal) && newVal.length === 2) {
						this.amap.setCenter(newVal);
					}
				},
				deep: true
			}
		},
		mounted() {
			// 初始化高德地图（确保DOM加载完成）
			this.initAmap();
		},
		beforeUnmount() {
			// 销毁地图实例，释放资源
			if (this.amap) {
				this.amap.destroy();
				this.amap = null;
			}
		},
		methods: {
			/**
			 * 初始化高德地图核心实例
			 */
			async initAmap() {
				try {
					// 加载高德地图API（官方加载器，确保加载完成）
					const AMap = await AMapLoader.load({
						key: AMAP_CONFIG.key,
						version: AMAP_CONFIG.version
					});

					// 存储AMap到实例，供全局方法使用
					this.AMap = AMap;

					// 创建地图实例，绑定DOM容器
					this.amap = new AMap.Map(this.$refs.amapRef, {
						zoom: 5, // 全国层级初始缩放
						zooms: [5, 20], //地图显示的缩放级别范围
						center: this.center, // 全国中心点
						mapStyle: AMAP_CONFIG.mapStyle,
						viewMode: "3D", // 地图模式
						terrain: true, //开启地形图
						pitch: 38, // 地图俯仰角度
						defaultCursor: "grab", // 默认鼠标样式
						resizeEnable: true // 允许自适应窗口大小
					});

					this.amap.on("mousedown", () => {
						this.amap.setDefaultCursor("grabbing");
					});

					this.amap.on("mouseup", () => {
						this.amap.setDefaultCursor("grab");
					});

					// 加载初始数据层（全国层级）
					this.renderNationalLayer();
				} catch (error) {
					console.error("高德地图初始化失败：", error);
					alert("地图加载失败，请检查高德Key配置或网络连接");
				}
			},

			// 根据 currentLevel 渲染对应图层
			renderCurrentLayer() {
				if (!this.amap) return;

				if (this.currentLevel === "national") {
					this.renderNationalLayer();
				} else if (this.currentLevel === "province") {
					this.renderProvinceLayer();
				} else if (this.currentLevel === "city") {
					this.renderCityLayer();
				}
			},

			/**
			 * 渲染全国层级数据层：省份换电站总数聚合
			 */
			renderNationalLayer() {
				// 清除之前的数据层（避免叠加）
				this.clearDataLayers();

				const nationalData = this.data.national || [];

				nationalData.forEach((item) => {
					// 创建 HTML 字符串作为 marker content
					const html = this.createCountHtml(item.count, item.name);
					// 1. 创建省份中心点标记（自定义样式，突出显示）
					const marker = new this.AMap.Marker({
						position: item.center,
						content: html, // 自定义图标：显示换电站总数
						offset: new this.AMap.Pixel(-30, 20)
					});

					marker.setExtData(item);

					marker.on("click", () => {
						// 下钻逻辑：触发地图 click 事件 path 中的处理
						// 直接调用下钻逻辑更稳：手动设置 currentLevel 并渲染
						if (this.currentLevel === "national") {
							this.currentLevel = "province";
							this.currentAdcode = item.code;
							this.currentName = item.name;
							this.renderProvinceLayer();
						}
					});

					// 3. 存储标记实例（用于后续清除）
					this.dataLayers.push(marker);
					// 4. 添加到地图
					this.amap.add(marker);
				});
			},

			/**
			 * 渲染省份层级数据层：各市换电站总数聚合
			 */
			renderProvinceLayer() {
				this.clearDataLayers();

				// 获取当前省份的市级数据
				const provinceData =
					(this.data.province || {})[this.currentAdcode] || [];
				if (!provinceData) return;

				// 调整地图视野到当前省份中心点
				const provinceInfo = this.data.national.find(
					(item) => item.code === this.currentAdcode
				);
				this.amap.setZoomAndCenter(7.2, provinceInfo.center); // 省份层级缩放级别：7.2

				provinceData.forEach((item) => {
					// 创建 HTML 字符串作为 marker content
					const html = this.createCountHtml(item.count, item.name);
					// 1. 创建市级中心点标记
					const marker = new this.AMap.Marker({
						position: item.center,
						content: html, // 自定义图标：显示换电站总数
						offset: new this.AMap.Pixel(-30, 20)
					});

					marker.setExtData(item);

					marker.on("click", () => {
						// 下钻逻辑：触发地图 click 事件 path 中的处理
						// 直接调用下钻逻辑更稳：手动设置 currentLevel 并渲染
						if (this.currentLevel === "province") {
							this.currentLevel = "city";
							this.currentAdcode = item.code;
							this.currentName = item.name;
							this.renderCityLayer();
						}
					});

					this.dataLayers.push(marker);
					this.amap.add(marker);
				});
			},

			/**
			 * 渲染区市层级数据层：具体换电站位置
			 */
			renderCityLayer() {
				this.clearDataLayers();

				// 获取当前区市的换电站数据
				const cityData = (this.data.city || {})[this.currentAdcode] || [];
				if (!cityData) return;

				// 调整地图视野到当前区市中心点
				const provinceData = this.data.province[this.currentParentAdcode()];

				const cityInfo = provinceData.find(
					(item) => item.code === this.currentAdcode
				);
				this.amap.setZoomAndCenter(10, cityInfo.center); // 区市层级缩放级别：12（街道级）

				// 根据资产类型设置图片缓存
				this.imageCache = IMAGE_CACHE_CONFIG[this.data.assetType] || null;

				// 先按坐标分组，记录每组内索引
				const posCount = {};

				cityData.forEach((item) => {
					const key = item.pos.join(",");
					posCount[key] = (posCount[key] || 0) + 1;
				});

				cityData.forEach((item) => {
					const key = item.pos.join(",");
					const count = posCount[key];
					const basePos = item.pos;

					let finalPos = basePos;
					if (count > 1) {
						// 计算偏移角度和距离
						const groupIndex = cityData
							.filter((d) => d.pos.join(",") === key)
							.findIndex((d) => d === item); // 获取在同组中的序号

						const radius = 0.00008; // 约 8 米偏移（根据缩放可调）
						const angle = (groupIndex * (360 / count) * Math.PI) / 180;
						finalPos = [
							basePos[0] + radius * Math.cos(angle),
							basePos[1] + radius * Math.sin(angle)
						];
					}

					// 1. 创建换电站标记（使用高德默认红色标记，突出显示）
					const marker = new this.AMap.Marker({
						position: finalPos,
						anchor: "bottom-center",
						zIndex: 1
					});

					marker.setContent(this.buildMarkerContent(item, marker));

					// 点击标记也可关闭信息窗口;
					marker.on("click", () => {
						// 换电柜详情
						if (item.assetType === "CABINET") {
							this.$router.push({
								name: "CabinetDetail",
								query: { cabinetSn: item.assetSn }
							});
						}
					});

					this.dataLayers.push(marker);
					this.amap.add(marker);
				});
			},

			/**
			 * marker添加dom节点
			 */
			buildMarkerContent(item, marker) {
				const div = document.createElement("div");
				div.className = "asset-marker";

				div.innerHTML = `
		           <img class="asset-icon" src="${this.imageCache}" />

		           <div class="asset-popup">
		             ${this.buildInfoWindowContent(item)}
		           </div>
		         `;

				div.addEventListener("mouseenter", () => {
					marker.setzIndex(9999); // 提到最上面
				});

				div.addEventListener("mouseleave", () => {
					marker.setzIndex(1); // 还原
				});

				return div;
			},

			// 提取信息窗口内容构建函数
			buildInfoWindowContent(item) {
				let label1, assetValue1, label2, assetValue2;
				switch (item.assetType) {
					case "STATION":
						label1 = "站点名称";
						assetValue1 = item.name || "暂无站点名称";
						label2 = "地址";
						assetValue2 = item.address || "暂无地址";
						break;
					case "CABINET":
						label1 = "部署编号";
						assetValue1 =
							(item.extraMap && item.extraMap.deploymentCode) || "暂无部署编号";
						label2 = "所属站点";
						assetValue2 =
							(item.extraMap && item.extraMap.stationName) || "暂无所属站点";
						break;
					case "VEHICLE":
						label1 = "车牌号";
						assetValue1 = item.name || "暂无车牌";
						label2 = "";
						assetValue2 = "";
						break;
					case "BATTERY":
						label1 = "电池sn";
						assetValue1 = item.assetSn || "暂无电池sn";
						label2 = "";
						assetValue2 = "";
						break;
					case "COMPARTMENT":
						label1 = "电池仓sn";
						assetValue1 = item.assetSn || "暂无电池仓sn";
						label2 = "";
						assetValue2 = "";
						break;
					default:
						label1 = "编码";
						assetValue1 = item.assetSn || "暂无编码";
						label2 = "";
						assetValue2 = "";

						break;
				}

				return `
			    <div class="info-window">
			      <div>
			        <div class="info-window-modal">
			          <img src="${infoBgImg}" alt="" />
			          <div class="info-window-con">
			            <p>
			              <span class="info-window-con-label">${label1}</span>
			              <span class="info-window-con-val">${assetValue1}</span>
			            </p>
			            <p>
			              <span class="info-window-con-label">${label2}</span>
			              <span class="info-window-con-val">${assetValue2}</span>
			            </p>
			          </div>
			        </div>
			      </div>
			    </div>
			  `;
			},

			/**
			 * 生成自定义 HTML 图标（返回字符串）
			 * @param {Number} count 换电站数量
			 * @param {String} name 换电站所在省份
			 * @returns {String}
			 */
			createCountHtml(count, name = "") {
				// 使用 import 导入的图片变量 shandongImg（确保上面已经 import）
				// 简单样式内联，或你也可以在 <style> 中写个 class
				return `<div class="AlarmConten canAnimation AlarmConten1">
						                 <div class="alarm-name">
						                   <span>${name}</span>
						                   <img style="display:none"
						                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAAYklEQVQoU43QsQ2AMAxE0X8DMAQdrILEcizDJrAINYfShdhBuLTfybLFz1LtbG/AKGlt8y2cgBPYJS01fsEysD0DR4sD7OEeLP0buCQNJZytDihA2ynKoOt1n1f3/p8ek+EHDhwnDB3y93UAAAAASUVORK5CYII="
						                   />
						                 </div>
						                 <div class="alarm-data">
						                   <p class="alarm-data-top">
						                     <span></span>
						                     <span class="caninet-total" data-citycode="1765251760763879426">
						                       ${count}
						                     </span>
						                   </p>
						                 </div>
						                 <div class="ringCon">
						                   <img
						                     class="ring ring1"
						                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAaCAYAAADrCT9ZAAAFGUlEQVRYR9WYSWxVZRTHf+e7b2hpa1tMKa1ARRESUTEGreIEdEBJlJWQ6MIploULE0OKtBQu6YAQYuLCBWgcFpqAKzGinUSJYKqNwYEYUIQCFiqhpba0fX3v3mPue32kQMtr5ZXqt7q597v/4XzTOZ/wL5utatp3YOVnI+fSkUQwNxagHBqh1/zYu3NtY8DoRdu70PwyHFvETcQ50veEQof/tL1V/ad7CA5cwJ/iiwnsHuqg/bhZYSLd4GSCQw4ui3HHK8y21fAo5tBZzPwcDOA7Dz4JRZ8vtmAETUkjnJdBaPVCCY/VfELDqir252SE00nzO1hxYIFISoT+AR8hFjM4XmNjFRjv580oviKQkkFwoIdUBV/8WziE43e5YD9Oj4jo1bBHN6wqdc1M7XOZii8WXZ9LOATdwU567JUyOF7Ryexv79IAM0inj6yIwU8IsHAdQ+fmIjoZxfiIhss/0YxgBrOcQYKeyAD83ZdOx9aHpCeZopOFVf6NZkzpJXcQbrAsFIfBUIgTW1dcqfcKw5X1OhNDgSfGr/T2n+fYlpUSX6rJ0jghOGt3aWZqFrPDQnqUwKWtdpmcHE52ieH1X+o843Czq6jP8LtdxLHRpsaEKE4GqLfnNDM74jLHFcRYHK9ZKoeH7T2xR7tJb4kodxtwjI8We4mcSQb/ZGHYe3W6G6HQBcsnHLSL5Q9PS3SE7U91ihPgSQSfEfZtKpETkyU0mbyVn2mB8fMwSsQaZLf9hPRFDVc26v0iLACO1hRLUzJJJxtrQ4MWuTBHfBysXiotUcMbmvRZV5lqKTs3lUr7ZItMJv/GBs13hFUqdNYWywdRw1WN+pp3zHZks2XHOLKWZAqbKKyyVvXndrEWiFSXyOtxw+uBNMtHrb1EeieKfDJw7b2a7kSoVKWvplSqo4bXN+jLAnNRPqpeJi2TIWyiOKvqtRDhaYUjNaXyVmzTqtdFIrwgwlmri42TnTYmy7yXfjrZbFIlRy3erS2SA7FjyVYTWUQdUCBCS3Uxb/7vEo7Lo6QqVU28okqhCMet/VTatrgXM63yBs0PwDYR0lBarD95w35eBpIV7euJY7+nKc5NvIpQqMoFC9bET59LUku7Sec6ymYgU4VTrsO2umXyy/UUe61cFfV6h7FYIy4zELotYZ1dLEeuSC3jL8r36IxggGqUeUPvmg28/V/PvtY26qwAvAQURXUrh0MRqrYul1PDgzhieeidXdO6eE7gRYVUr+4wwtfq8rF1gG+9tXCtI5GM/729x1nEA2J4Sl0Wq1csKAMI75zJ5v2Rcoqr3nhUfKF5xqJMYKVEy2IvcHSgNGBo7DhK647VY79eSYbJsu3qz72VhbiUIJQCuUO4gwofuw7b6x6T06NxJbzi8X5ct0dzfEFWicszSqxWHmr9QKsI37nwoy+Vn+wH5a9kGItj2Pt1WqSfu4AFKPcJLCQ266JNoE0NH0ZC7Ny8XM4m4h6T4eEgFc16j+WwAkMJyu3ximtYn26E30RpA9oRTqvS5UC3uPRgGDQWYcLeOsGPS8AyZOCSpYZslDwR8lTw7jlvQ8kczq/iTTJ+NVAfMeyuK5IfEplMuIbHClDRpLni8ogx0ajfi3InkHWJQI2VoBITOmrT0fudR/gZ+N51aVXDvrpi6Rirxsv7jXuEExFFg+Awz7KYqcpMEaarko1ERy9dwI/G9gMEb92FEXpRukToUuWMCCcdh5NqcfhazI2kNemGEwVksr//A50x6yq9/Rt9AAAAAElFTkSuQmCC"
						                   />
						                   <img
						                     class="ring ring2"
						                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAaCAYAAADrCT9ZAAAFGUlEQVRYR9WYSWxVZRTHf+e7b2hpa1tMKa1ARRESUTEGreIEdEBJlJWQ6MIploULE0OKtBQu6YAQYuLCBWgcFpqAKzGinUSJYKqNwYEYUIQCFiqhpba0fX3v3mPue32kQMtr5ZXqt7q597v/4XzTOZ/wL5utatp3YOVnI+fSkUQwNxagHBqh1/zYu3NtY8DoRdu70PwyHFvETcQ50veEQof/tL1V/ad7CA5cwJ/iiwnsHuqg/bhZYSLd4GSCQw4ui3HHK8y21fAo5tBZzPwcDOA7Dz4JRZ8vtmAETUkjnJdBaPVCCY/VfELDqir252SE00nzO1hxYIFISoT+AR8hFjM4XmNjFRjv580oviKQkkFwoIdUBV/8WziE43e5YD9Oj4jo1bBHN6wqdc1M7XOZii8WXZ9LOATdwU567JUyOF7Ryexv79IAM0inj6yIwU8IsHAdQ+fmIjoZxfiIhss/0YxgBrOcQYKeyAD83ZdOx9aHpCeZopOFVf6NZkzpJXcQbrAsFIfBUIgTW1dcqfcKw5X1OhNDgSfGr/T2n+fYlpUSX6rJ0jghOGt3aWZqFrPDQnqUwKWtdpmcHE52ieH1X+o843Czq6jP8LtdxLHRpsaEKE4GqLfnNDM74jLHFcRYHK9ZKoeH7T2xR7tJb4kodxtwjI8We4mcSQb/ZGHYe3W6G6HQBcsnHLSL5Q9PS3SE7U91ihPgSQSfEfZtKpETkyU0mbyVn2mB8fMwSsQaZLf9hPRFDVc26v0iLACO1hRLUzJJJxtrQ4MWuTBHfBysXiotUcMbmvRZV5lqKTs3lUr7ZItMJv/GBs13hFUqdNYWywdRw1WN+pp3zHZks2XHOLKWZAqbKKyyVvXndrEWiFSXyOtxw+uBNMtHrb1EeieKfDJw7b2a7kSoVKWvplSqo4bXN+jLAnNRPqpeJi2TIWyiOKvqtRDhaYUjNaXyVmzTqtdFIrwgwlmri42TnTYmy7yXfjrZbFIlRy3erS2SA7FjyVYTWUQdUCBCS3Uxb/7vEo7Lo6QqVU28okqhCMet/VTatrgXM63yBs0PwDYR0lBarD95w35eBpIV7euJY7+nKc5NvIpQqMoFC9bET59LUku7Sec6ymYgU4VTrsO2umXyy/UUe61cFfV6h7FYIy4zELotYZ1dLEeuSC3jL8r36IxggGqUeUPvmg28/V/PvtY26qwAvAQURXUrh0MRqrYul1PDgzhieeidXdO6eE7gRYVUr+4wwtfq8rF1gG+9tXCtI5GM/729x1nEA2J4Sl0Wq1csKAMI75zJ5v2Rcoqr3nhUfKF5xqJMYKVEy2IvcHSgNGBo7DhK647VY79eSYbJsu3qz72VhbiUIJQCuUO4gwofuw7b6x6T06NxJbzi8X5ct0dzfEFWicszSqxWHmr9QKsI37nwoy+Vn+wH5a9kGItj2Pt1WqSfu4AFKPcJLCQ266JNoE0NH0ZC7Ny8XM4m4h6T4eEgFc16j+WwAkMJyu3ximtYn26E30RpA9oRTqvS5UC3uPRgGDQWYcLeOsGPS8AyZOCSpYZslDwR8lTw7jlvQ8kczq/iTTJ+NVAfMeyuK5IfEplMuIbHClDRpLni8ogx0ajfi3InkHWJQI2VoBITOmrT0fudR/gZ+N51aVXDvrpi6Rirxsv7jXuEExFFg+Awz7KYqcpMEaarko1ERy9dwI/G9gMEb92FEXpRukToUuWMCCcdh5NqcfhazI2kNemGEwVksr//A50x6yq9/Rt9AAAAAElFTkSuQmCC"
						                   />
						                   <img
						                     class="ring ring3"
						                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAaCAYAAADrCT9ZAAAFGUlEQVRYR9WYSWxVZRTHf+e7b2hpa1tMKa1ARRESUTEGreIEdEBJlJWQ6MIploULE0OKtBQu6YAQYuLCBWgcFpqAKzGinUSJYKqNwYEYUIQCFiqhpba0fX3v3mPue32kQMtr5ZXqt7q597v/4XzTOZ/wL5utatp3YOVnI+fSkUQwNxagHBqh1/zYu3NtY8DoRdu70PwyHFvETcQ50veEQof/tL1V/ad7CA5cwJ/iiwnsHuqg/bhZYSLd4GSCQw4ui3HHK8y21fAo5tBZzPwcDOA7Dz4JRZ8vtmAETUkjnJdBaPVCCY/VfELDqir252SE00nzO1hxYIFISoT+AR8hFjM4XmNjFRjv580oviKQkkFwoIdUBV/8WziE43e5YD9Oj4jo1bBHN6wqdc1M7XOZii8WXZ9LOATdwU567JUyOF7Ryexv79IAM0inj6yIwU8IsHAdQ+fmIjoZxfiIhss/0YxgBrOcQYKeyAD83ZdOx9aHpCeZopOFVf6NZkzpJXcQbrAsFIfBUIgTW1dcqfcKw5X1OhNDgSfGr/T2n+fYlpUSX6rJ0jghOGt3aWZqFrPDQnqUwKWtdpmcHE52ieH1X+o843Czq6jP8LtdxLHRpsaEKE4GqLfnNDM74jLHFcRYHK9ZKoeH7T2xR7tJb4kodxtwjI8We4mcSQb/ZGHYe3W6G6HQBcsnHLSL5Q9PS3SE7U91ihPgSQSfEfZtKpETkyU0mbyVn2mB8fMwSsQaZLf9hPRFDVc26v0iLACO1hRLUzJJJxtrQ4MWuTBHfBysXiotUcMbmvRZV5lqKTs3lUr7ZItMJv/GBs13hFUqdNYWywdRw1WN+pp3zHZks2XHOLKWZAqbKKyyVvXndrEWiFSXyOtxw+uBNMtHrb1EeieKfDJw7b2a7kSoVKWvplSqo4bXN+jLAnNRPqpeJi2TIWyiOKvqtRDhaYUjNaXyVmzTqtdFIrwgwlmri42TnTYmy7yXfjrZbFIlRy3erS2SA7FjyVYTWUQdUCBCS3Uxb/7vEo7Lo6QqVU28okqhCMet/VTatrgXM63yBs0PwDYR0lBarD95w35eBpIV7euJY7+nKc5NvIpQqMoFC9bET59LUku7Sec6ymYgU4VTrsO2umXyy/UUe61cFfV6h7FYIy4zELotYZ1dLEeuSC3jL8r36IxggGqUeUPvmg28/V/PvtY26qwAvAQURXUrh0MRqrYul1PDgzhieeidXdO6eE7gRYVUr+4wwtfq8rF1gG+9tXCtI5GM/729x1nEA2J4Sl0Wq1csKAMI75zJ5v2Rcoqr3nhUfKF5xqJMYKVEy2IvcHSgNGBo7DhK647VY79eSYbJsu3qz72VhbiUIJQCuUO4gwofuw7b6x6T06NxJbzi8X5ct0dzfEFWicszSqxWHmr9QKsI37nwoy+Vn+wH5a9kGItj2Pt1WqSfu4AFKPcJLCQ266JNoE0NH0ZC7Ny8XM4m4h6T4eEgFc16j+WwAkMJyu3ximtYn26E30RpA9oRTqvS5UC3uPRgGDQWYcLeOsGPS8AyZOCSpYZslDwR8lTw7jlvQ8kczq/iTTJ+NVAfMeyuK5IfEplMuIbHClDRpLni8ogx0ajfi3InkHWJQI2VoBITOmrT0fudR/gZ+N51aVXDvrpi6Rirxsv7jXuEExFFg+Awz7KYqcpMEaarko1ERy9dwI/G9gMEb92FEXpRukToUuWMCCcdh5NqcfhazI2kNemGEwVksr//A50x6yq9/Rt9AAAAAElFTkSuQmCC"
						                   />
						                 </div>
						               </div>`;
			},

			/**
			 * 清除当前数据层（切换层级时调用，避免数据叠加）
			 */
			clearDataLayers() {
				if (this.dataLayers.length > 0) {
					this.amap.remove(this.dataLayers);
					this.dataLayers = [];
				}
			},

			/**
			 * 返回上一级按钮逻辑
			 */
			handleBack() {
				if (this.currentLevel === "city") {
					// 区市 -> 省份
					const provinceAdcode = this.currentParentAdcode(); // e.g. 370200 -> 370000
					const provinceInfo = this.data.national.find(
						(item) => item.code === provinceAdcode
					);

					// 恢复状态与视野
					this.currentLevel = "province";
					this.currentAdcode = provinceAdcode;

					if (provinceInfo) {
						this.currentName = provinceInfo.name;
						// 省级视野（可改为 setZoomAndCenter 的动画形式）
						this.amap.setZoomAndCenter(8, provinceInfo.center);
					} else {
						// 保底处理：如果找不到，仍然渲染省级但不移动地图
						console.warn("没有找到 provinceInfo：", provinceAdcode);
						this.currentName = "省级";
					}

					this.renderProvinceLayer();
				} else if (this.currentLevel === "province") {
					// 省份 -> 全国
					this.currentLevel = "national";
					this.currentAdcode = "";
					this.currentName = "全国";
					this.amap.setZoomAndCenter(5, [108.0, 36.0]);
					this.renderNationalLayer();
				}
			},
			/**
			 * 获取返回按钮文本
			 */
			getBackLevelText() {
				return this.currentLevel === "city" ? "省份视图" : "全国视图";
			},

			/**
			 * 获取当前层级文本
			 */
			getCurrentLevelText() {
				const typeName = this.getAssetTypeName(this.data.assetType);
				if (this.currentLevel === "national") return `全国${typeName}分布`;
				if (this.currentLevel === "province")
					return `${this.currentName}${typeName}分布`;
				return `${this.currentName}${typeName}分布`;
			},

			/**
			 * 匹配资产名称
			 */
			getAssetTypeName(type) {
				const map = {
					STATION: "换电站",
					CABINET: "换电柜",
					VEHICLE: "车辆",
					COMPARTMENT: "电池仓",
					BATTERY: "电池"
				};
				return map[type] || ""; // 若未匹配，返回原值（避免 undefined）
			},

			/**
			 * 获取当前区市的父级省份Adcode（如青岛370200的父级是山东370000）
			 */
			currentParentAdcode() {
				const ad = String(this.currentAdcode || "");
				// 6 位市级（如 370200） -> 返回 省级 370000
				if (ad.length === 6) {
					return ad.slice(0, 2) + "0000";
				}
				// 4 位（若你有 3700 这种）也归为省级 370000
				if (ad.length === 4) {
					return ad.slice(0, 2) + "0000";
				}
				// 其他情况，直接返回原值（保底）
				return ad;
			}
		}
	};
</script>

<style>
	/* 默认手型 */
	#amap {
		cursor: grab;
	}

	/* 按下时抓手 */
	#amap:active {
		cursor: grabbing;
	}

	.amap-marker,
	.amap-marker *,
	.amap-icon,
	.amap-icon * {
		cursor: pointer !important;
	}
	/* 地图容器：占满全屏（适配大屏） */
	.map-container {
		position: relative;
		width: 1920px;
		height: 1080px;
	}

	/* 高德地图容器：必须设置固定尺寸，否则无法渲染 */
	.amap-wrapper {
		width: 100%;
		height: 100%;
	}

	/* 交互控件样式：参考Vdata简洁风格 */
	.map-controls {
		position: absolute;
		/* top: 920px; */
		left: 1220px;
		z-index: 100; /* 确保在地图之上 */
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	/* 返回按钮 */
	.back-btn {
		padding: 8px 16px;
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		transition: background 0.3s;
	}

	.back-btn:hover {
		background: rgba(0, 0, 0, 0.2);
	}

	.level-indicator {
		padding: 8px 16px;
		background: rgba(0, 0, 0, 0.2);
		color: #fff;
		border-radius: 4px;
		font-size: 14px;
	}

	/* 全国省份图标样式 */
	.AlarmConten1 {
		background-image: url(data:image/png;base64,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);
		background-repeat: no-repeat;
	}
	.canAnimation {
		animation: opacityChange 0.4s ease-out;
	}
	@keyframes opacityChange {
		0% {
			opacity: 0;
			bottom: -80px;
		}
		90% {
			bottom: 25px;
		}
		100% {
			opacity: 1;
			bottom: 20px;
		}
	}
	.AlarmConten {
		position: absolute;
		left: 0px;
		width: 68px;
		height: 83px;
		opacity: 1;
		bottom: 20px;
		transform: scale(0.9);
	}
	.alarm-name {
		text-align: left;
		height: auto;
		line-height: 20px;
		padding: 4px 0 2px 10px;
		/* 新增：限制最多两行 */
		display: -webkit-box;
		-webkit-line-clamp: 2; /* 限制行数 */
		-webkit-box-orient: vertical; /* 设置排列方向 */
		overflow: hidden; /* 隐藏溢出 */
		text-overflow: ellipsis; /* 添加省略号（对多行需配合上述属性） */
	}
	.alarm-data {
		text-align: left;
		padding-left: 10px;
	}
	.alarm-data-top {
		margin-top: 4px;
		margin-bottom: 6px;
		height: 13px;
		line-height: 13px;
	}
	.alarm-data-top span:nth-of-type(1) {
		display: inline-block;
		width: 6px;
		height: 6px;
		background: #28fffa;
		border-radius: 6px;
		vertical-align: middle;
	}

	.ringCon {
		position: relative;
		margin-top: 24px;
	}
	.ring {
		position: absolute;
		top: 10px;
		width: 60px;
		left: 3px;
		opacity: 0;
	}
	.ring1 {
		animation: ringScale 6s infinite linear;
	}
	.ring2 {
		animation: ringScale 6s 2s infinite linear;
	}
	.ring3 {
		animation: ringScale 6s 4s infinite linear;
	}
	@keyframes ringScale {
		0% {
			opacity: 1;
			transform: scale(0);
		}
		70% {
			opacity: 1;
		}
		100% {
			opacity: 0;
			transform: scale(1);
		}
	}

	/* marker 容器 */
	.asset-marker {
		position: relative;
		cursor: pointer;
	}

	/* 图标 */
	.asset-icon {
		width: 40px;
		height: 40px;
		display: block;
	}

	/* popup 默认隐藏 */
	.asset-popup {
		display: none;
		position: absolute;
		top: -10px;
		left: -20px;
		white-space: nowrap;
	}

	/* hover 显示 */
	.asset-marker:hover .asset-popup {
		display: block;
	}

	/* 气泡样式 */
	/* 单站图标图标样式 */
	.info-window {
		width: 448px;
		height: 121px;
	}

	.info-window-modal {
		display: inline-block;
		position: absolute;
		top: 0;
		left: 52px;
		opacity: 1;
		width: 391px;
		overflow: hidden;
		/* 兜底：底图加载失败时保持弹窗高度，避免文字被 overflow:hidden 裁掉 */
		/* min-height: 121px; */
		animation: moveRight 1.2s ease-in-out;
	}

	@keyframes moveRight {
		0% {
			width: 0;
		}
		100% {
			width: 391px;
		}
	}

	.info-window-modal img {
		width: 391px;
	}

	.info-window-con {
		position: absolute;
		color: #ffffff;
		top: 30px;
		left: 45px;
		width: 328px;
		line-height: 25px;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: middle;
	}
	.info-window-con p {
		margin: 0;
		padding: 0;
		display: flex;
		align-items: center;
	}

	.info-window-con-label {
		display: inline-block;
		color: #719dff;
		min-width: 62px;
		margin-right: 6px;
	}

	.info-window-con-val {
		display: inline-block;
		width: 260px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: wrap; /* 临时可以换行 */
		vertical-align: middle;
	}
</style>
